import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const imgSrc = (u) => (!u ? "" : u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const GalleryStrip = () => {
    const [photos, setPhotos] = useState([]);

    useEffect(() => {
        axios.get(`${API}/gallery`).then((r) => setPhotos(r.data)).catch(() => {});
    }, []);

    if (photos.length === 0) return null;

    return (
        <section id="gallery" data-testid="gallery-section" className="bg-white py-24 lg:py-32 border-t border-line">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                    className="mb-12"
                >
                    <p className="font-mono text-[11px] tracking-[0.35em] text-gold mb-6" data-testid="gallery-overline">
                        FROM OUR FLOOR
                    </p>
                    <h2 className="font-heading font-extrabold tracking-tighter text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.05]" data-testid="gallery-heading">
                        FACTORY & SHOWROOM.
                    </h2>
                </motion.div>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="gallery-grid-public">
                    {photos.map((p, i) => (
                        <motion.div
                            key={p.id}
                            initial={{ clipPath: "inset(100% 0 0 0)" }}
                            whileInView={{ clipPath: "inset(0% 0 0 0)" }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.8, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                            className="h-[220px] md:h-[280px] overflow-hidden group"
                            data-testid={`gallery-photo-${p.id}`}
                        >
                            <img src={imgSrc(p.url)} alt={p.caption || "Zam Zam Furnitures factory"} loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
